import { createResource } from '@atlassian/react-resource-router';
import getData from './get-data/index.tsx';

export const csmCustomerContextMigratedTenantStatusResource = createResource<boolean>({
	type: 'CSM_MIGRATED_TENANT_STATUS',
	getKey: () => 'csm-customer-context-migrated-tenant-status',
	getData: async () => getData(),
	maxAge: 1000 * 60 * 60 * 24, // 1 day
});
